module.exports = __webpack_public_path__ + "static/media/signup_top_right.299fe875.png";